import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import StatusDate from '../StatusDate';
import CheckmarkIcon from '../../../../icons/checkmark.svg';
import ShipmentStatusIcon from '../ShipmentStatus/ShipmentStatusIcon';
import { getLastTimelineStatusIndex } from '../statusHelper';
import {Heading} from '../../StyledComponents';

import styles from './StatusTimeline.module.scss';

class StatusTimeline extends React.PureComponent {

  render() {
    const {
      isMobile,
      data,
      showDate,
      showIcon,
      hideFutureStates,
      mobileOrder,
      designSettings: {
        timelineTextColor,
        timelineIconBackgroundColor: iconBackgroundColor,
        timelineIconColor: iconColor,
        headingFontSize,
        headingFont,
        bodyFontSize,
        bodyFont,
        timelineBackgroundColor: backgroundColor,
        bodyBordersAndLinesColor,
      },
      locale,
      contentLibraryPreview,
    } = this.props;

    if (!data.length) {
      return null;
    }

    const reverseOrder = mobileOrder === 'newestFirst';
    const lastStatusIndex = getLastTimelineStatusIndex(data);
    const lastStatusLineIndex = lastStatusIndex + (reverseOrder || !isMobile ? 1 : 0);

    return (
      <div styleName="container" style={{ backgroundColor }}>
        <div
          styleName={classnames('status-timeline', {
            mobile: isMobile,
            desktop: !isMobile,
            'content-library-preview': contentLibraryPreview,
            'oldest-first': mobileOrder === 'oldestFirst',
            'newest-first': mobileOrder === 'newestFirst',
          })}
        >
          { data.map((status, i) => {
            const {
              date,
              message,
            } = status;

            const isFirstItem = i === 0;
            const isLastItem = i === (data.length - 1);

            const isCurrentStatus = i === lastStatusIndex;
            const isPastStatus = i < lastStatusIndex;
            const isFutureStatus = i > lastStatusIndex;

            const showStatusName = !(hideFutureStates && isFutureStatus);

            const statusItemClass = classnames('status-item', {
              'no-date' : isFutureStatus,
              'last-date': isCurrentStatus,
            });

            const circleColor = !isFutureStatus ? iconBackgroundColor : bodyBordersAndLinesColor;
            const textColor = isFutureStatus ? bodyBordersAndLinesColor : timelineTextColor;
            const lineColor = i < lastStatusLineIndex ? iconBackgroundColor : bodyBordersAndLinesColor;

            return (
              <div styleName={statusItemClass} style={{ borderColor: lineColor }} key={i}>
                { isFirstItem && <div styleName="first-item-before" style={{ backgroundColor }}/>}
                { (isLastItem || isCurrentStatus) && (
                  <div
                    styleName="last-item-before"
                    style={{ backgroundColor: (isLastItem || isMobile) ? backgroundColor : bodyBordersAndLinesColor }}
                  />
                ) }
                <div styleName="status-icon" style={{ borderColor: lineColor }}>
                  <div styleName="rounded" style={{ backgroundColor: circleColor }}>
                    { showIcon && isCurrentStatus && (
                      <ShipmentStatusIcon styleName="icon" name={status.icon} size={20} fill={iconColor} />
                    ) }
                    { showIcon && isPastStatus && (
                      <CheckmarkIcon styleName="icon" style={{ fill: iconColor }} />
                    ) }
                  </div>
                </div>
                <div styleName="status-content">
                  { showStatusName && (
                    <div styleName="status-name">
                      <Heading
                        type="headingSecondary"
                        isMobile={isMobile}
                        fontSize={headingFontSize}
                        font={headingFont}
                        color={textColor}
                      >
                        {message}
                      </Heading>
                    </div>
                  ) }
                  { showDate && date && (
                    <div styleName="status-date">
                      <StatusDate
                        fontType="bodyTertiary"
                        fontSize={bodyFontSize}
                        font={bodyFont}
                        date={date}
                        styles={{
                          date: styles['status-date-time'],
                          icon: styles['status-date-icon'],
                        }}
                        color={textColor}
                        locale={locale}
                      />
                    </div>
                  ) }
                </div>
              </div>
            ) }
          ) }
        </div>
      </div>
    );
  }
}

StatusTimeline.defaultProps = {
  data: [],
  mobileOrder: 'newestFirst',
};

StatusTimeline.propTypes = {
  isMobile: PropTypes.bool,
  data: PropTypes.arrayOf(PropTypes.object),
  showIcon: PropTypes.bool,
  showDate: PropTypes.bool,
  mobileOrder: PropTypes.oneOf(['newestFirst', 'oldestFirst']),
  designSettings: PropTypes.shape({
    headingFont:PropTypes.string,
    headingFontSize: PropTypes.string,
    bodyFont:PropTypes.string,
    bodyFontSize:PropTypes.string,
    timelineTextColor: PropTypes.string,
    bodyBordersAndLinesColor: PropTypes.string,
    timelineIconBackgroundColor: PropTypes.string,
    timelineBackgroundColor: PropTypes.string,
    timelineIconColor: PropTypes.string,
  }),
  locale: PropTypes.string,
  contentLibraryPreview: PropTypes.bool,
};

export default StatusTimeline;


// WEBPACK FOOTER //
// ./src/js/widgets/Status/StatusTimeline/StatusTimeline.js